import React from "react";
import styles from "./switch.module.css";

const Switch = ({ isOn, handleToggle, leftText, rightText}) => {
  return (
      <button 
        className={styles.Toggle} 
        onClick={handleToggle}>

        <span 
          className={isOn ? styles.ToggleTextOn : styles.ToggleTextOff}>
            {isOn ? rightText : leftText}
        </span>

        <div 
          className={isOn ? styles.ThumbOn : styles.ThumbOff}>

          <span 
            className={styles.ThumbText}>
              {isOn ? leftText : rightText}
          </span>

        </div>
      </button>
  );
};

export default Switch;
